import axios from 'axios';
import { config } from '../config/config';
import { customNavigate } from './navigation';
import { broadcastConnectionError } from '../pages/Login';

const axiosInstance = axios.create({
  baseURL: config.API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true // This is important for CORS
});

// List of endpoints that don't need authorization
const noAuthEndpoints = [
  '/api/v1/auth/login/'
];

// Add a request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Skip adding token for specific endpoints
    if (noAuthEndpoints.includes(config.url || '')) {
      return config;
    }

    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Flag to prevent multiple connection error dialogs
let hasShownConnectionError = false;

axiosInstance.interceptors.response.use(
  (response) => {
    // Reset the flag when we have successful responses
    hasShownConnectionError = false;
    return response;
  },
  (error) => {
    // Handle connection errors (network errors)
    if (!error.response) {
      console.error('Network error: Could not connect to the server');
      
      // Only show the error once to avoid multiple dialogs
      if (!hasShownConnectionError) {
        hasShownConnectionError = true;
        
        // Use the login component's connection error handling
        broadcastConnectionError(true, 5);
        
        // If not on login page, redirect to login
        if (window.location.pathname !== '/login') {
          localStorage.removeItem('token');
          customNavigate('/login');
        }
      }
      
      return Promise.reject(new Error('Network error: Could not connect to the server'));
    }

    if (error.response) {
      // Handle 401 Unauthorized error
      if (error.response.status === 401 && !noAuthEndpoints.includes(error.config.url)) {
        // Clear any stored authentication data
        localStorage.removeItem('token');
        // Redirect to login page
        customNavigate('/login');
        // Reload the page to reset the app state
        window.location.reload();
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance; 